import styled from "styled-components";
import Image from "../../../../components/Image";
import ButtonUi from "../../../../components/Button";

export const ButtonViewLater = styled.button`
  background-color: #ffffff;
  color: #000000;
  border: 1px solid #d0d0d0;
  border-radius: 24px;
  padding: 11px 24px;
  font-size: 16px;
  line-height: 21px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  min-width: 165px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    min-width: 0;
  }

  &:hover {
    background-color: #f2f2f2;
  }
`;

// Botón "Explorar ahora 🎉"
export const ButtonExporeNow = styled.a`
  background-color: #000000;
  color: #ffffff;
  border: none;
  padding: 12px 16px;
  border-radius: 24px;
  font-size: 16px;
  line-height: 21px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  min-width: 165px;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    min-width: 0;
  }

  &:hover {
    background-color: #333333;
  }
`;

export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    flex-direction: row;
  }
`

export const Title = styled.div`
  font-size: 20px;
  text-align: center;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.Primary};

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    font-size: 26px;
  }
`;

export const Text = styled.div`
  font-size: 14px;
  text-align: center;

  @media (min-width: ${(props) => props.theme.mediaBreakpoints.smMin}) {
    font-size: 16px;
  }
`;